const supplierBasePath = '/suppliers';


const SupplierConst = {
  basePath: supplierBasePath
};


export default SupplierConst;